"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Textarea = void 0;
var React = _interopRequireWildcard(require("react"));
var _classify = require("../../utils/classify");
var _Text = require("../Text");
var _TextareaModule = _interopRequireDefault(require("./Textarea.module.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Textarea_ = (props, ref) => {
  const {
    value,
    onChange,
    onFocus,
    onBlur,
    name,
    disabled,
    placeholder,
    error,
    locked,
    errorText,
    label,
    helperText,
    classNames,
    size = 'medium',
    required,
    textCountLimit,
    ...textareaProps
  } = props;
  const [textCountError, setTextCountError] = React.useState(false);
  React.useEffect(() => {
    if (textCountLimit) {
      if (value && value.length > textCountLimit) {
        setTextCountError(true);
      } else {
        setTextCountError(false);
      }
    }
  }, [value]);
  const controlledTextareaFilled = value !== '';
  return /*#__PURE__*/React.createElement("div", {
    className: (0, _classify.classify)(_TextareaModule.default.wrapper, {
      [_TextareaModule.default.filled]: controlledTextareaFilled ?? false,
      [_TextareaModule.default.withError]: (error || textCountError) ?? false
    })
  }, Boolean(label) && /*#__PURE__*/React.createElement("div", {
    className: _TextareaModule.default.info
  }, /*#__PURE__*/React.createElement("div", {
    className: _TextareaModule.default.infoContent
  }, /*#__PURE__*/React.createElement(_Text.FormLabelSmall, {
    color: "secondary"
  }, label ?? ''), "\xA0", required && /*#__PURE__*/React.createElement(_Text.FormLabelSmall, {
    color: "danger"
  }, '*')), /*#__PURE__*/React.createElement(_Text.FormLabelSmall, {
    color: error || textCountError ? 'danger' : 'secondary'
  }, !!textCountLimit && (value && value.length || 0) + '/' + textCountLimit)), /*#__PURE__*/React.createElement("div", {
    className: (0, _classify.classify)(_TextareaModule.default.box, {
      [_TextareaModule.default.inputDisabled]: disabled ?? false,
      [_TextareaModule.default.medium]: size === 'medium',
      [_TextareaModule.default.small]: size === 'small',
      [_TextareaModule.default.locked]: locked
    }, classNames?.box)
  }, /*#__PURE__*/React.createElement("textarea", _extends({}, textareaProps, {
    disabled: locked || disabled,
    name: name,
    ref: ref,
    placeholder: placeholder,
    value: value,
    onChange: onChange,
    onFocus: onFocus,
    onBlur: onBlur,
    className: classNames?.textarea
  }))), (Boolean(helperText) || error) && /*#__PURE__*/React.createElement("div", {
    className: _TextareaModule.default.info
  }, /*#__PURE__*/React.createElement(_Text.BodySmall, {
    color: error && errorText ? 'danger' : disabled ? 'disabled' : 'secondary'
  }, error && errorText ? errorText : helperText ?? '')));
};
const Textarea = /*#__PURE__*/React.forwardRef(Textarea_);
exports.Textarea = Textarea;